/** When to apply a new service worker (see pwa.js). Pure, so it can be unit tested. */
export const FRESH_MS = 10_000;

export function decideUpdate({ sinceLoadMs, hidden }) {
  return sinceLoadMs < FRESH_MS || hidden ? 'now' : 'when-hidden';
}
